import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Projects } from '../../../../pages/project/Projects';
import { projectsSearchSchema } from '../../../../routing/schemas';

export const Route = createFileRoute('/_private/_home/project/')({
  validateSearch: projectsSearchSchema,
  component: ProjectsRoute,
});

function ProjectsRoute() {
  const { apiClient } = Route.useRouteContext();
  return <Projects portalApiClient={apiClient} />;
}
